export const roundWithDecimal = (number) => Math.round(number * 100) / 100;

export const addCommasToThousands = (number) => number.toLocaleString();
